import AxiosInstance from "../../AxiosInstance";

const Billing_report = "ob/billing";
const BillingbaseUrl = '/operation';
const MasterbaseUrl = '/master';
const ReportsbaseUrl = '/Reports';

const BillingReportsService = {
    reportJobBillDetails: (details) => {
        return AxiosInstance.post(Billing_report + '/reportJobBillDetails', details)
    },
    getBillPrintTo: () => {
        return AxiosInstance.get(Billing_report + '/getBillPrintTo')
    },
    getCurrencyName: () => {
        return AxiosInstance.get(BillingbaseUrl + '/getCurrencyName')
    },
    getJobCurrencyDetails: (consignmentId) => {
        return AxiosInstance.get(BillingbaseUrl + '/getJobCurrencyDetails?consignmentId=' + consignmentId)
    },
    updateCurrencyRate: (details) => {
        return AxiosInstance.put(BillingbaseUrl + '/updateCurrencyRate', details)
    },
    getGstNo: (jobNo) => {
        return AxiosInstance.get(ReportsbaseUrl + '/getGstNo?jobNo=' + jobNo)
    },
    InvoiceBillPdfPrint: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/InvoiceBillPdfPrint', details)
    },
    reportJobDetails: (details) => {
        return AxiosInstance.post(Billing_report + '/reportJobDetails', details)
    },
    getDeliveryStateName: () => {
        return AxiosInstance.get(MasterbaseUrl + '/getDeliveryStateName')
    },
    showMultipleBill: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/showMultipleBill', details)
    },
    MultipleInvoiceBillPdfPrint: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/MultipleInvoiceBillPdfPrint', details)
    },
    getImporter: (details) => {
        return AxiosInstance.post(Billing_report + '/getImporter', details)
    },
    getImporterBranch: (details) => {
        return AxiosInstance.post(Billing_report + '/getImporterBranch', details)
    },
    getCombinedInvoiceSummary: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/getCombinedInvoiceSummary', details)
    },
    getCombinedInvoiceDetails: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/getCombinedInvoiceDetails', details)
    },
    combinedInvoiceSummaryPdf: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/combinedInvoiceSummaryPdf', details)
    },
    combinedInvoiceDetailsPdf: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/combinedInvoiceDetailsPdf', details)
    },
    getSupplementaryBillBasedOnJobNo: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/getSupplementaryBillBasedOnJobNo', details)
    },
    SupplementaryInvoiceBillPdfPrint: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/SupplementaryInvoiceBillPdfPrint', details)
    },
    showSupplementaryBill: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/showSupplementaryBill', details)
    },
    getImporterDetail: () => {
        return AxiosInstance.get(MasterbaseUrl + '/getImporterDetails')
    },
    selectFwdDetails: () => {
        return AxiosInstance.get(Billing_report + '/selectFwdDetails')
    },
    QuotationPdfPrint: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/QuotationPdfPrint', details)
    },
    getImporterDetails: () => {
        return AxiosInstance.get(ReportsbaseUrl + '/getImporterDetails')
    },
    getDeliveryStateNameAll: (stateId) => {
        return AxiosInstance.get(MasterbaseUrl + '/getDeliveryStateNameAll?stateId' + stateId)
    },
    getRegionBasedOnState: (stateId) => {
        return AxiosInstance.get(MasterbaseUrl + '/getRegionBasedOnState?stateId=' + stateId)
    },
    ///selectBillPaidBy is replaced by it for tallyintigration report.......if anyofother pages need then cal it then use it either erace it
    getbillpaidby: () => {
        return AxiosInstance.get(Billing_report + '/getbillpaidby')
    },
    getBillPaidTo: () => {
        return AxiosInstance.get(Billing_report + '/getBillPaidTo')
    },
    getBillPaidToSelective: () => {
        return AxiosInstance.get(Billing_report + '/getBillPaidToSelective')
    },
    reportTallyIntegration: (details) => {
        return AxiosInstance.post(Billing_report + '/reportTallyIntegration', details)
    },
    Excelwrite: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/write', details)
    },
    reportBillingSummary: (details) => {
        return AxiosInstance.post(Billing_report + '/reportBillingSummary', details)
    },
    selectBillPaidBy: () => {
        return AxiosInstance.get(Billing_report + '/selectBillPaidBy')
    },
    reportBillingDetails: (details) => {
        return AxiosInstance.post(Billing_report + '/reportBillingDetails', details)
    },
    getRegionalOfficeDetails: () => {
        return AxiosInstance.get(ReportsbaseUrl + '/getRegionalOfficeDetails')
    },
    getGSTR1Report: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/getGSTR1Report', details)
    },
    GSTR1_report: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/GSTR1_report', details)
    },
    getCustomerBillDetailsReport: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/getCustomerBillDetailsReport', details)
    },
    billDetails_report: (details) => {
        return AxiosInstance.post(ReportsbaseUrl + '/billDetails_report', details)
    },
    getVoucherTypeAll: () => {
        return AxiosInstance.get(Billing_report + '/getVoucherTypeAll')
    },
    getBankName: (ip_org_id) => {
        return AxiosInstance.get(BillingbaseUrl + '/getBankName?ip_org_id=' + ip_org_id)
    },
    getOrgName: () => {
        return AxiosInstance.get(BillingbaseUrl + '/getOrgName')
    },
    getDashboardDetails: (userId, flag) => {
        return AxiosInstance.get(BillingbaseUrl + '/getDashboardDetails?userId=' + userId + '&flag=' + flag);
    },
    getdashboardReport: (userId, flag) => {
        return AxiosInstance.get(BillingbaseUrl + '/getdashboardReport?userId=' + userId + '&flag=' + flag);
    },

    get_bill_edit: (job_no, Bill_no) => {
        return AxiosInstance.get(BillingbaseUrl + '/get_bill_edit?job_no=' + job_no + '&Bill_no=' + Bill_no)
    },

    update_bill_status: (bill_dto, Bill_no) => {
        return AxiosInstance.put(BillingbaseUrl + '/update_bill_status?flag=' + Bill_no, bill_dto)
    },
    jobDetails: (details) => {
        return AxiosInstance.post(Billing_report + '/SP_report_get_job_details_by_date', details)
    },

}
export default BillingReportsService;